import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { OperatorMutationKeys } from '../../../keys'
import { deleteGroup } from '../../services'

interface UseMutationDeleteGroupProps {
	id: string
}

export default function useMutationDeleteGroup(
	props?: UseBaseMutationOptions<void, UseMutationDeleteGroupProps>,
) {
	return useMutation({
		mutationKey: [OperatorMutationKeys.DeleteGroup],
		mutationFn: ({ id }) => deleteGroup(id),
		...props,
	})
}
